import type { Fen, GradedMove } from '@chess/api-model';
import type { OpeningBook } from '@chess/api-openings';

// The opening variation at each of the reader's opening moves (2026-10-10),
// as the book names the position after the move: the "Your moves" squares'
// tooltips, "3.Bc4 · Italian Game". Only while the book still knows the
// position; a known position without a name of its own takes the deepest
// name the game passed through on the way to it (the game's positions, when
// given, else the earlier squares'). After the book exit a square has none
// and its tooltip keeps the grade.

/** The book's name at each move it still knows, by 1-based ply. */
export function moveNames(book: Pick<OpeningBook, 'lookup' | 'knows'>, moves: readonly GradedMove[], positions: readonly Fen[] = []): Record<number, string> {
  const out: Record<number, string> = {};
  let last: string | undefined;
  let walked = 0;
  for (const m of moves) {
    // The positions up to this move, their names carried forward.
    for (; walked < m.ply && walked + 1 < positions.length; walked++) last = book.lookup(positions[walked + 1])?.name ?? last;
    const fen = m.fen ?? positions[m.ply];
    if (!fen || !book.knows(fen)) continue;
    const name = book.lookup(fen)?.name ?? last;
    if (name) out[m.ply] = last = name;
  }
  return out;
}
